import axios, { AxiosResponse } from 'helper/axios-facade';
import appConfig from 'helper/mapBackendConfig';
import { OPTIONAL_ITEM_TYPES } from 'store/optionalProgramItems';
import { ContentTypeOptionalWorkoutDtoType } from 'types/services/magnolia/dtos/ContentTypeOptionalWorkoutDto';
import { GetProgramItemsByContentIdentifiers } from 'types/services/magnolia/GetProgramItemsByContentIdentifiers';
import { ProgramItemDtoType } from 'types/services/spring/dtos/ProgramItemDto';

export const putItemCompleted = (programItemId: number): Object | void => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programitems/${programItemId}/check`;
	return axios.put(requestURL);
};

export const putWorkoutItemCompleted = (programItemId: number, calories: number): Object | void => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programitems/${programItemId}/workout/check`;

	return axios.put(requestURL, {}, { params: { calories } });
};

export const postReplaceWorkoutWithCustomItem = (
	programItemId: number,
	workoutExternalId: string,
	duration: number,
	met: number
): Object | void => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programitems/${programItemId}/workout/custom`;
	const params = { params: { workoutExternalId, duration, met } };
	return axios.post(requestURL, {}, params);
};

export const putWorkoutCustomItemUpdate = (
	programItemId: number,
	workoutExternalId: string,
	duration: number,
	met: number
): Object | void => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programitems/${programItemId}/workout/custom`;
	const params = { params: { workoutExternalId, duration, met } };
	return axios.put(requestURL, {}, params);
};

export const putItemClose = (programItemId: number): Object | void => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programitems/${programItemId}/close`;
	return axios.put(requestURL);
};

export const postTracking = (programItemId: number, data: Object): Object | void => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programitems/${programItemId}/tracking`;
	return axios.post(requestURL, data, { params: data });
};
export const putTracking = (programItemId: number, data: Object): Object | void => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programitems/${programItemId}/tracking`;
	return axios.put(requestURL, data, { params: data });
};

export const putSlogan = (programItemId: number, slogan: string): Object | void => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programitems/${programItemId}/slogan`;
	return axios.put(requestURL, {
		slogan,
	});
};

export const fetchProgramItemsContents = (
	programItemContentIdentifiers: string
): Promise<AxiosResponse<GetProgramItemsByContentIdentifiers>> => {
	const requestURL = `${appConfig.env.urlMagnoliaAPICoach}/programitems/${programItemContentIdentifiers}`;
	return axios.get(requestURL, { withCredentials: false, headers: { Accept: 'application/json' } });
};

export const putSwapItem = (
	programItemId: string,
	contentType: string,
	externalId: string
): Promise<AxiosResponse<ProgramItemDtoType>> => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programitems/${programItemId}/${contentType}/swap`;

	return axios.put(
		requestURL,
		{},
		{
			params: {
				externalId,
			},
		}
	);
};

export const getOptionalContent = <T>(id: string): Promise<AxiosResponse<T>> => {
	const requestURL = `${appConfig.env.urlMagnoliaAPICoach}/programitems/optional/${id}`;

	return axios.get(requestURL, { withCredentials: false, headers: { Accept: 'application/json' } });
};

export const getOptionalWorkout = (): Promise<AxiosResponse<ContentTypeOptionalWorkoutDtoType>> => {
	return getOptionalContent(OPTIONAL_ITEM_TYPES.WORKOUT);
};

export const getOptionalRecipe = (): Promise<AxiosResponse<any>> => {
	return getOptionalContent(OPTIONAL_ITEM_TYPES.RECIPE);
};

export const postCreateFromOptional = (
	programItemId: string,
	contentType: string,
	externalId: string,
	dayNumber: number
): Promise<AxiosResponse<any>> => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programitems/create/${contentType}`;

	return axios.post(requestURL, {
		externalId,
		dayNumber,
		programItemExternalId: programItemId,
	});
};

export const postCreateCustomFromOptional = (
	contentType: string,
	programItemExternalId: string,
	dayNumber: number,
	exerciseExternalId: string,
	duration: number,
	met: number
): Promise<AxiosResponse<any>> => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programitems/create/${contentType}/custom`;
	return axios.post(requestURL, {
		dayNumber,
		duration,
		exerciseExternalId,
		met,
		programItemExternalId,
	});
};

export const postMoveProgramItem = (
	programItemExternalId: number,
	direction: 'postpone' = 'postpone',
	days: number = 1
): Promise<AxiosResponse<any>> => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programitems/move/${programItemExternalId}/${direction}/${days}`;
	return axios.post(requestURL);
};
